import styled from 'styled-components';
import { Link } from 'react-router-dom';

export const Container = styled(Link)`
  display: flex;
  gap: 8px;
  transition: 300ms;
  transform: scale(${props => props.scale});
  margin-bottom: ${({ $marginBottom }) => `${$marginBottom}px`};
  cursor: pointer;

  :hover {
    opacity: .8;
  }
`;

export const LogoStyled = styled.img`
  width: 105px;
  
  ${({ theme }) => theme.old.breakpoints.isMobile} {
    width: 75px;
  }
`

export const CreatorsLogo = styled.img`
  height: 26px;
  width: 111px;
  margin-top: 8px;
  
  ${({ theme }) => theme.old.breakpoints.isMobile} {
    width: 80px;
    margin-top: 5px;
  }
`
